import {
  TAX_SUMMARY_FETCHING,
  TAX_SUMMARY_FAILED,
  TAX_SUMMARY_SUCCESS,
} from "./types";

import TaxSummaryService from "../services/taxSummary.service";

export const getTaxSummary = (year) => async (dispatch) => {
  try {
    dispatch({
      type: TAX_SUMMARY_FETCHING,
    });

    const res = await TaxSummaryService.getTaxSummary(year);

    if (res) {
      dispatch({
        type: TAX_SUMMARY_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: TAX_SUMMARY_FAILED,
      payload: null,
    });
    console.log(err);
  }
};
